"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleAPICalledEvent = void 0;
const utils_1 = require("../../utils");
const RemoteObject_1 = require("./RemoteObject");
class ConsoleAPICalledEvent {
    constructor({ type, argumentsList, timestamp }, executionContextId, getObjectId) {
        this.args = [];
        this.type = type;
        this.timestamp = timestamp;
        this.executionContextId = executionContextId;
        argumentsList.forEach((value) => {
            const objectId = (0, utils_1.isObject)(value) ? getObjectId(value) : undefined;
            this.args.push(new RemoteObject_1.RemoteObject(value, objectId));
        });
    }
}
exports.ConsoleAPICalledEvent = ConsoleAPICalledEvent;
